import { createTheme } from "@mui/material/styles"

export default createTheme({
    palette: {
        primary: {
            main: "#4D7BA2"
        },
        background: {
            default: "#121212"
        }
    },
    typography: {
        fontFamily: "'Montserrat', 'Roboto',sans-serif"
    }
})